import styled from "styled-components";

export const Container = styled.div`
    display: flex;
    justify-content: space-evenly;
    align-items: center; 
    flex-direction: column;
    min-height: 100vh;
    width: 100%;
    font-size: 1rem; 
`;